import { useEffect, useState } from 'react';
import { ChevronsUp } from 'react-feather';

/** CUBA TapTop — scroll-to-top control */
export function TapTop() {
  const [display, setDisplay] = useState<'none' | 'block'>('none');

  useEffect(() => {
    const onScroll = () => setDisplay(window.scrollY > 600 ? 'block' : 'none');
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="tap-top" style={{ display }}>
      <ChevronsUp
        onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })}
      />
    </div>
  );
}
